var _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBullet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.23,
    strokeLinecap: "round",
    d: "M4.412 1.461h6.767M4.412 5.152h6.767M4.412 8.844h6.767"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.949,
    cy: 1.461,
    r: 1.23,
    fill: "#000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.949,
    cy: 5.152,
    r: 1.23,
    fill: "#000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.949,
    cy: 8.844,
    r: 1.23,
    fill: "#000"
  })));
}
export default SvgBullet;